import React from "react";
import { Button, DropdownButton, MenuItem } from "react-bootstrap";
import { getAddressString } from "../../extensions/addressHelper";
import { formatPhone } from "../../extensions/phoneHelper";
import { formatDate } from "../../extensions/dateHelper";
import { withRouter } from "react-router";
import * as permissions from '../../constants/permissions';
import SmsSendModal from "../common/SmsSendModal";

const renderHeader = () => (
    <thead>
        <tr>
            <td>Телефон</td>
            <td>Имя</td>
            <td>Email</td>
            <td>Адрес</td>
            <td>День рождения</td>
            <td>Активен</td>
            <td></td>
            <td></td>
            <td></td>
        </tr>
    </thead>
);

const renderRow = (customer, editClick, history, onSmsSendOpen) => {
    const { Id, Phone, Name, Email, Address, DateOfBirth, User: { IsActive } } = customer;
    const isReceptionPoint = permissions.getRole() == permissions.RECEPTION_POINT;
    const pathToAllOrders = isReceptionPoint ? '/orders/all-on-points' : '/orders/all';
    return (
        <tr key={Id}>
            <td>{formatPhone(Phone)}</td>
            <td>{Name}</td>
            <td>{Email}</td>
            <td>{Address ? getAddressString(Address) : ''}</td>
            <td>{formatDate(DateOfBirth)}</td>
            <td>{IsActive ? 'Да' : 'Нет'}</td>
            <td>
                <Button onClick={() => editClick(customer)}>Редактировать</Button>
            </td>
            <td>
                <DropdownButton title='Уведомить' >
                    <MenuItem href={`https://wa.me/${Phone}`} target="_blank">WhatsApp</MenuItem>
                    <MenuItem href={`https://t.me/${Phone}`} target="_blank">Telegram</MenuItem>
                    <MenuItem onClick={() => onSmsSendOpen(Phone)}>Телефон</MenuItem>
                </DropdownButton>
            </td>
            <td>
                <Button onClick={() => history.push(`${pathToAllOrders}?phone=${encodeURIComponent(Phone)}`)}>Заказы</Button>
            </td>
        </tr>
    );
}

const renderBody = ({ entities: customers, editClick, history, parentProps }) => (
    <tbody>
        {customers && customers.map((customer) => renderRow(customer, editClick, history, parentProps.onSmsSendOpen))}
    </tbody>
);

const Table = (props) => {
    return(
    <table className="table table-hover">
        {renderHeader()}
        {renderBody(props)}
    </table>
)};

export default withRouter(Table);


// WEBPACK FOOTER //
// ./src/components/customers/Table.jsx